import { Plugin, PluginKey } from "prosemirror-state";

interface ToolbarPanelState {
  activePanel: number;
}

export const toolbarPanelPluginKey = new PluginKey<ToolbarPanelState>("toolbarPanel");

/** Creates a plugin that tracks which toolbar panel is active (0-indexed, default 0). */
export function toolbarPanelPlugin(): Plugin<ToolbarPanelState> {
  return new Plugin<ToolbarPanelState>({
    key: toolbarPanelPluginKey,
    state: {
      init: () => ({ activePanel: 0 }),
      apply(tr, value) {
        const meta = tr.getMeta(toolbarPanelPluginKey) as { activePanel: number } | undefined;
        if (meta?.activePanel !== undefined) return { activePanel: meta.activePanel };
        return value;
      },
    },
  });
}
